export default __webpack_public_path__ + "static/media/photo_gallery_6.bc01a2c7.png";